import logo1 from "../../assets/images/sections/Brands/logomarks/apple.png";
import logo2 from "../../assets/images/sections/Brands/logomarks/microsoft.png";
import logo3 from "../../assets/images/sections/Brands/logomarks/vw.png";
import logo4 from "../../assets/images/sections/Brands/logomarks/ubuntu.png";
import logo5 from "../../assets/images/sections/Brands/logomarks/playstation.png";
import logo6 from "../../assets/images/sections/Brands/logomarks/hp.png";
import logo7 from "../../assets/images/sections/Brands/logomarks/lg.png";
import logo8 from "../../assets/images/sections/Brands/logomarks/android.png";
import logo9 from "../../assets/images/sections/Brands/logomarks/shell.png";
import logo10 from "../../assets/images/sections/Brands/logomarks/dell.png";
import logo11 from "../../assets/images/sections/Brands/logomarks/ea.png";
import logo12 from "../../assets/images/sections/Brands/logomarks/intel.png";
import logo13 from "../../assets/images/sections/Brands/logomarks/html5.png";
import logo14 from "../../assets/images/sections/Brands/logomarks/avg.png";

const logomarks = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo14,
  logo13,
  logo12,
  logo11,
  logo10,
  logo9,
  logo8,
  logo7,
  logo6,
  logo5,
  logo4,
  logo3,
  logo2,
  logo1
];

export default logomarks;
